import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: i * 0.12 } }),
};

export const MaskLines = ({ lines, className = "", lineClassName = "", onLoad = false, testId }) => {
  const trigger = onLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <motion.span className={`block ${className}`} {...trigger} data-testid={testId}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className={`block ${lineClassName}`} variants={lineVariants} custom={i}>
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
